import Vue from 'vue'
import Router from 'vue-router'
import landing from '../pages/landing.vue'
import graphs from '../pages/graphs.vue'
import graph from '../pages/graph.vue'
import graphFit from '../pages/graph-fit.vue'
import fallbackPage from '../pages/404.vue'

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Esileht',
            component: landing

        },
        {
            path: '/graphs/:area/:village/:section/:graphName',
            name: 'Tulud',
            component: graph
        },
        {
            path: '*',
            name: '404',
            component: fallbackPage
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.ts